<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'
import { useI18n } from 'vue-i18n'
import { Icon } from '@/components/ui/icon'

const { t } = useI18n()
const fatalError = ref<string | null>(null)

onErrorCaptured((err) => {
  fatalError.value = err instanceof Error ? err.message : String(err)
  return false // prevent propagation
})

function clearError() {
  fatalError.value = null
}
</script>

<template>
  <div v-if="fatalError" role="alert" class="flex min-h-screen items-center justify-center bg-background">
    <div class="flex flex-col items-center gap-4 text-center max-w-md px-6">
      <Icon name="alert-triangle" :size="64" class="text-destructive" />
      <h1 class="text-xl font-semibold text-foreground">{{ t('errors.somethingWentWrong') }}</h1>
      <p class="text-sm text-muted-foreground">{{ fatalError }}</p>
      <button class="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90" @click="clearError">
        {{ t('common.retry') || 'Retry' }}
      </button>
    </div>
  </div>
  <template v-else>
    <router-view />
  </template>
</template>
